import { useState } from 'react';
import { PdfDocumentViewer } from '@/components/learning/PdfDocumentViewer';
import { useAuthenticatedBlobUrl } from '@/hooks/useAuthenticatedBlobUrl';
import { Loader } from '@lms/ui';

export interface PdfFolderEntry {
  mediaFileId: string;
  title: string;
  mediaUrl: string;
}

function FolderPdf({ file }: { file: PdfFolderEntry }) {
  const { blob, blobUrl, error, loading } = useAuthenticatedBlobUrl(file.mediaUrl);
  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader label="Cargando PDF…" />
      </div>
    );
  }
  if (error || !blob || !blobUrl) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center text-sm text-red-700">
        {error ?? 'No se pudo cargar el archivo.'}
      </div>
    );
  }
  return <PdfDocumentViewer file={blob} downloadUrl={blobUrl} title={file.title} />;
}

export function PdfFolderPlayer({ files }: { files: PdfFolderEntry[] }) {
  const [activeId, setActiveId] = useState(files[0]?.mediaFileId ?? '');
  const active = files.find((file) => file.mediaFileId === activeId) ?? files[0];

  if (!active) {
    return (
      <div className="rounded-xl border border-dash-outline-variant bg-white p-8 text-center text-sm text-dash-on-surface-variant">
        Esta carpeta no tiene PDF publicados.
      </div>
    );
  }

  return (
    <div className="lms-pdf-folder">
      <nav className="lms-pdf-folder__nav" aria-label="PDF de la carpeta">
        <ol>
          {files.map((file, index) => {
            const selected = file.mediaFileId === active.mediaFileId;
            return (
              <li key={file.mediaFileId}>
                <button
                  type="button"
                  className={`lms-pdf-folder__item${selected ? ' lms-pdf-folder__item--active' : ''}`}
                  aria-current={selected ? 'true' : undefined}
                  onClick={() => setActiveId(file.mediaFileId)}
                >
                  <span className="lms-pdf-folder__index">{index + 1}</span>
                  <span className="min-w-0 truncate">{file.title || `PDF ${index + 1}`}</span>
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
      <div className="lms-pdf-folder__viewer">
        <FolderPdf key={active.mediaFileId} file={active} />
      </div>
    </div>
  );
}
